
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.293 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 1.293L1.293 0l5.5 5.5-5.5 5.5L0 9.708 4.2 5.5 0 1.293m5.5 0L6.793 0l5.5 5.5-5.5 5.5L5.5 9.708 9.7 5.5z","fill":"#fff"}})])
          )
        }
      }
    